import { handleActions, combineActions } from 'redux-actions';

import actions from '@synergycms_app/store/actions';
import { List } from 'immutable';

const notificationsActions = actions.notifications;
const notifications = handleActions(
  {
    [combineActions(
      notificationsActions.send.toString(),
      notificationsActions.show.toString(),
      notificationsActions.hide.toString()
    )]: (type, { payload }) => {
      return payload;
    }
  },
  List()
);

export default notifications;
